import { Link } from "react-router-dom";
import SectionHeader from "@/components/feature/SectionHeader";
import type { EditorPick } from "@/types/work";

interface Props {
  picks: EditorPick[];
}

export default function EditorPicks({ picks }: Props) {
  return (
    <section>
      <SectionHeader
        title="编辑推荐专题"
        subtitle="由编辑部策划的伦理影视合集，按主题带你系统浏览"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
        {picks.map((pick) => (
          <Link
            key={pick.id}
            to={pick.link}
            className="group relative rounded-lg overflow-hidden border border-background-200 h-[220px] md:h-[240px] bg-primary-950"
          >
            <img
              src={pick.cover}
              alt={`${pick.title}专题封面`}
              title={`${pick.title} 韩国伦理影视专题`}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/45 to-foreground-950/10" />
            <div className="relative h-full p-5 flex flex-col justify-end text-background-50">
              <span className="self-start px-2 py-0.5 rounded-md bg-accent-500 text-[11px] font-semibold mb-3">
                {pick.subtitle}
              </span>
              <h3 className="font-heading font-bold text-xl md:text-2xl">{pick.title}</h3>
              <p className="mt-2 text-sm text-background-50/75 line-clamp-2 max-w-2xl">
                {pick.description}
              </p>
              <div className="mt-3 flex items-center gap-2 text-xs text-background-50/70">
                <span>共 {pick.count} 部作品</span>
                <span className="w-px h-3 bg-background-50/30" />
                <span className="flex items-center gap-1 group-hover:text-accent-400 transition-colors">
                  进入专题 <i className="ri-arrow-right-line" />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}